import {HintsGroup} from "./Hint";
import {Tour} from "./Tour";

import PlayerData from "./data/PlayerData";
import HomeData from "./data/HomeData";
import ChallengesData from "./data/ChallengesData";
import SongPageData from "./data/SongPageData";
import CatalogPageData from "./data/CatalogPageData";

export const introJsData: any = {
  tours: [
    ...PlayerData.tours,
    ...HomeData.tours,
    ...ChallengesData.tours,
    ...SongPageData.tours
  ] as Tour[],
  hints: [
    ...HomeData.hints,
    ...SongPageData.hints,
    ...CatalogPageData.hints
  ] as HintsGroup[]
};
